import Session from './session';
import { openWindowsWindow } from './windowsAuth';
import { getSamlJwtFromDeepLink } from '../../utils/sso';
import { Browser } from '@capacitor/browser';

Session.clean();
/**
 * @constructor
 * @param {Object} options
 * @param {String} options.domain your domain
 */
export const Djangosaml2ClientAuth = function (options) {
    this.domain = options.domain;
    this.nextURl = encodeURIComponent(`/api/v3/sso/redirect_mobile/?token=${options.state}`);
    this.authorizeUrl = `${options.domain}/saml2/login/?idp=${options.entityId}&next=${this.nextURl}`;
};

// Logs a user into their IdP and starts the process to get the user logged into the mobile app.
Djangosaml2ClientAuth.prototype.getDjangosaml2Response = function () {
    return new Promise((resolve) => {
        Session.start((sessionError, token) => {
            // This code will be called last. It closes the agent/mobile web window and returns the JWT in the expected workflow.
            if (sessionError != null) {
                resolve({ error: sessionError, token: null });
                return;
            }
            Browser.close();
            resolve({ error: null, token });
            return;
        });

        Browser.open({ url: this.authorizeUrl });

        Browser.addListener('browserFinished', () => {
            const handleClose = () => {
                if (Session.isClosing) {
                    Session.clean();
                    resolve({ error: new Error('user canceled'), token: null });
                    return;
                }
            };

            Session.closing();

            handleClose();
        });
    });
};

// Starts the process for closing the mobile web window. Passes the token along.
Djangosaml2ClientAuth.onRedirectUri = function (token) {
    Session.onRedirectUri(token);
};

/**
 * Common handler for the authorization response
 */
Djangosaml2ClientAuth.prototype._parseAuthorizeResponseWindows = function (redirectUrl) {
    // Perform a small error check and return the user’s JWT.

    if (!redirectUrl || typeof redirectUrl !== 'string') {
        return { error: new Error('url must be a string'), token: null };
    }

    const token = getSamlJwtFromDeepLink(redirectUrl);

    return { error: null, token };
};

Djangosaml2ClientAuth.prototype.authorizeWindows = async function () {
    // Open the SSO login window
    const { error, redirectUrl } = await openWindowsWindow({
        requestUri: this.authorizeUrl,
        redirectUri: `zenput://saml2/`
    });

    if (error != null) {
        return { error, token: null };
    }
    return this._parseAuthorizeResponseWindows(redirectUrl);
};
